import React, { useState } from 'react';
import { connect } from 'react-redux';
import { selectMyMfaDetails } from '../../Redux/IdentityRedux';
import './MfaEnrollmentBanner.scss';

const MfaEnrollmentBanner = ({ myMfaDetails }) => {
   const [dismissed, setDismissed] = useState(false);

   if (!myMfaDetails || dismissed) return null;

   const { totpEnrolledDate, smsEnrolledDate, enforcementDate, enforcementDateMessage } = myMfaDetails;
   const isEnrolled = !!totpEnrolledDate || !!smsEnrolledDate;

   if (isEnrolled || !enforcementDate) return null;

   const enforcement = new Date(enforcementDate);
   if (new Date() >= enforcement) return null;

   const formattedDate = enforcement.toLocaleDateString('en-NZ', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
   });

   const bannerText = enforcementDateMessage || `You have not enrolled in multi-factor authentication (MFA). Please enrol on or before ${formattedDate}.`;

   return (
      <div className="container">
         <div className="row center-align no-margin-bottom">
            <div className="col l12">
               <div className="card-panel close-panel-padding lighten-2 orange no-margin-bottom mfa-enrollment-card">
                  <a
                     onClick={() => setDismissed(true)}
                     href="#hide"
                     className="black-text"
                  >
                     <i className="material-icons right">close</i>
                  </a>
                  <h5>Multi-factor Authentication Enrolment</h5>
                  <span>{bannerText}</span>
               </div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => ({
   myMfaDetails: selectMyMfaDetails(state),
});

export default connect(mapStateToProps)(MfaEnrollmentBanner);
